var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrorB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.a-icon-error-b{fill:rgba(233,0,0,0.2);}.b-icon-error-b,.d-icon-error-d{fill:none;}.b-icon-error-b{stroke:#e90000;stroke-width:2.5px;}.c-icon-error-b{stroke:none;}\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-653 -267)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(264 -35)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a-icon-error-b",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(389 302)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(673.164 286.164)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b-icon-error-b",
    y2: 19.43,
    transform: "translate(13.74 0) rotate(45)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b-icon-error-b",
    x1: 19.43,
    transform: "translate(0 0) rotate(45)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(662 275)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b-icon-error-b",
    transform: "translate(36 0) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c-icon-error-b",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d-icon-error-d",
    cx: 18,
    cy: 18,
    r: 16.75
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorB);
export default __webpack_public_path__ + "static/media/icon-error_b.479804b500f740701fefc299db1a4460.svg";
export { ForwardRef as ReactComponent };